<div class="banner-swiper-container pb-2">
    <div class="position-relative container rounded-4 mx-width-45" [hidden]="!showSwiper">
        <swiper [config]="swiperConfig" class="w-100 rounded-4">
                @if(userWithAutoGrowth === false){
                    <ng-template class="w-100" swiperSlide>
                        <div class="home-banner w-100">
                            <div class="container">
                                <div class="banner m-3 m-lg-0">
                                    <div class="row">
                                        <div class="col-6 order-1 order-lg-0 py-3">
                                            <div class="d-flex flex-column align-items-start w-100 h-100 justify-content-center ps-md-3 py-3">
                                                <h5 class="lh-sm title mb-0">
                                                    <span class="cl-black fw-sbold">¡Que tu dinero</span><br>
                                                    <span class="cl-blue fw-sbold">crezca sin esfuerzo!</span>
                                                </h5>
                                                <div class="subtitle-div">
                                                    <p class="cl-black subtitle clamp-text fs-14 fw-light mb-2">Invertir en bienes raices <span class="fw-sbold cl-black">nunca fue tan facil. </span>Con AutoGrowth, tus ahorros...</p>
                                                </div>
                                                <div class="d-flex align-items-center justify-content-start w-100">
                                                    <a class="btn bg-primary cl-white rounded-4 px-4" [routerLink]="path.ROUTE_MY_SETTINGS_AUTOINVEST">Conoce más</a>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-6 order-0 order-lg-1">
                                            <div class="d-flex align-items-center justify-content-end h-100">
                                                <img class="w-100" src="https://static.monific.com/assets/assets-app/img/banners/link-card-banner-01.svg" alt="banner-reference">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                }
                @if(userWithDomiciliation === false){
                    <ng-template class="w-100" swiperSlide>
                        <div class="home-banner w-100">
                            <div class="container pb-2">
                                <div class="banner m-3 m-lg-0">
                                    <div class="row">
                                        <div class="col-6 order-1 order-lg-0 py-3">
                                            <div class="d-flex flex-column align-items-start w-100 h-100 justify-content-center ps-md-3 py-3">
                                                <h5 class="lh-sm title mb-0">
                                                    <span class="cl-black fw-sbold">¡Mantén tus fondos</span><br>
                                                    <span class="cl-blue fw-sbold">siempre trabajando!</span>
                                                </h5>
                                                <div class="subtitle-div">
                                                    <p class="cl-black subtitle fs-14 fw-light mb-2 clamp-text">Vincula tu tarjeta y asegúrate de que nunca falte dinero para seguir invirtiendo automáticamente.</p>
                                                </div>
                                                <div class="d-flex align-items-center justify-content-start w-100">
                                                    <a class="btn bg-primary cl-white rounded-4 px-4" [routerLink]="path.ROUTE_MY_SETTINGS_DOMICILIATION">Conoce más</a>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-6 order-0 order-lg-1">
                                            <div class="d-flex align-items-center justify-content-end h-100">
                                                <img class="w-100" src="https://static.monific.com/assets/assets-app/img/banners/link-card-banner-02.svg" alt="banner-reference">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                }
        </swiper>
    </div>
</div>